import React from "react";
import SharedButton from "components/shared/button/button";
import Text from "components/shared/text/text";
import Confetti from "../../assets/images/confetti.svg";
import Box from "@mui/material/Box";
import { styled, useTheme } from "@mui/material/styles";
import { useNavigate, useLocation } from "react-router-dom";
import { ROUTE_ACTIVE_JOBS } from "routes/route-items";
import { firestore, db } from "utils/firebase";
import { collection_name } from "utils/firebase-refs";
import { RootState, useAppDispatch } from "redux/store";
import { useSelector } from "react-redux";
import { doActionFetchUserAction } from "redux/services/user/user.actions";
import CircularProgress from "@mui/material/CircularProgress";

const Wrapper = styled("div")`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media only screen and (max-width: 599px) {
    background: ${({ theme }) => theme.palette.grey[50]};
  }
`;

const Image = styled("img")`
  height: 160px;
  width: 160px;
  margin-bottom: 60px;
`;

const JobOnboardingComplete = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  const location = useLocation();

  const [isLoading, setLoading] = React.useState(false);

  const userState = useSelector(
    (reduxState: RootState) => reduxState.user.response
  );

  const getStarted = async () => {
    setLoading(true);
    if (userState.uid) {
      try {
        const userRef = firestore.doc(
          db,
          collection_name.v2_clients,
          userState.uid
        );

        await firestore.setDoc(
          userRef,
          { next_onboarding_stage: ROUTE_ACTIVE_JOBS },
          { merge: true }
        );
        dispatch(
          doActionFetchUserAction({
            uid: userState.uid,
            user: {
              ...userState,
              next_onboarding_stage: ROUTE_ACTIVE_JOBS,
            },
          })
        );
        navigate(`/${ROUTE_ACTIVE_JOBS}`);
      } catch (error) {
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
    navigate(`/${ROUTE_ACTIVE_JOBS}`);
  };

  return (
    <Wrapper>
      <Image src={Confetti} alt="Hi" loading="lazy" />
      <Text
        variant="h2"
        fontSize="40px"
        fontWeight={600}
        lineHeight="48px"
        letterSpacing="-0.03em"
        sx={{
          marginBottom: "1rem",
          marginLeft: 0,
          textAlign: "center",
        }}
      >
        {location.state != null && (location.state as { skip: boolean }).skip
          ? "Onboarding completed!"
          : "Your job is kicked off!"}
      </Text>
      <Text
        variant="body1"
        color={theme.palette.grey[400]}
        marginBottom="40px"
        sx={{
          marginLeft: 0,
          maxWidth: "30rem",
        }}
      >
        {location.state != null && (location.state as { skip: boolean }).skip
          ? "You can create your first job in your Connect dashboard. Make sure to add your requirements, so our recruiters can start adding relevant candidates to the job."
          : "You can find it in your Connect dashboard. Make sure to add your requirements, so our recruiters can start adding relevant candidates to the job."}
      </Text>
      <SharedButton
        onClick={getStarted}
        variant="contained"
        sx={{ minWidth: "16rem", width: "auto" }}
      >
        <Box
          sx={{
            marginLeft: "6px",
            textTransform: "initial",
            display: "flex",
            alignItems: "center",
          }}
        >
          {isLoading && (
            <CircularProgress
              sx={{ marginRight: "10px" }}
              color="inherit"
              size="20px"
            />
          )}
          {isLoading ? "Loading ..." : "Get started"}
        </Box>
      </SharedButton>
    </Wrapper>
  );
};

export default JobOnboardingComplete;
